import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '@app/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
    
    isInitialized: boolean = false;
    
    constructor(
        private httpClient: HttpClient,
        public translateService: TranslateService,
        private alertController: AlertController
    ) { }
    
    supportNotification(){
        return ("Notification" in window);
    }
    
    async checkNotificationPermission(){
        if (Notification.permission === "default"){
            const alert = await this.alertController.create({
                message: this.translateService.instant('NOTIFICATION.MSG_REQUEST_PERMISSION'),
                buttons: [{
                        text: this.translateService.instant('NOTIFICATION.BTN_DENY'),
                        role: 'cancel'
                    },
                    {
                        text: this.translateService.instant('NOTIFICATION.BTN_GRANT'),
                        role: 'confirm',
                        handler: () => {                        
                            this.requestNotificationPermission();
                        }
                    }                    
                ],
            })
            await alert.present();    
        } 
        else if(Notification.permission === "granted"){
            this.registerServiceWorker(false);
        }
    } 
    
    async requestNotificationPermission(){
        Notification.requestPermission(async (permission) => {            
            if (permission === "granted") {
                await this.registerServiceWorker();
            }
        });
    }
    
    async registerServiceWorker(saveSubscription: boolean = true) {
        let registration = await navigator.serviceWorker.register("/workers/notification.worker.js");
        let subscription: PushSubscription|null = await registration.pushManager.getSubscription();
        if (!subscription) {
            let publicKey = await this.getPublicKey();
            if(publicKey !== null){
                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: publicKey,
                });
                saveSubscription = true;
            }
        }
        if (saveSubscription && subscription !== null) {
            await this.saveSubscription(subscription);
        }
    }
    
    async getPublicKey(): Promise<string|null>{
        return new Promise ((resolve) => {
            this.httpClient.get(environment.URL_API_BACKEND_REST+'notifications/public-key').subscribe(
                (response: any) => { 
                    let publicKey = (response?.key ? response.key : null);
                    resolve(publicKey);
                },
                () => {
                    resolve(null);
                }
            );   
        });
    }
    
    async saveSubscription(subscription: PushSubscription): Promise<boolean> {
        return new Promise ((resolve) => {
            let body: any = {
                subscription: subscription.toJSON()
            };
            this.httpClient.post(environment.URL_API_BACKEND_REST+'notifications/register', body, {withCredentials: true}).subscribe(
                (response: any) => { 
                    resolve(response?.res);
                },
                () => {
                    resolve(false);
                }
            );   
        });
    }
    
    init(){
        if(!environment.production && !this.isInitialized){
            this.isInitialized = true;
            if(this.supportNotification()){
                this.checkNotificationPermission();            
            }
        }
    }
}

